module.exports = __webpack_public_path__ + "img/ew-icon_journistic.ca078dfe.svg";